import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./ProfileDetails.css";

const ProfileDetails = ({ photographerName, data }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  if (!photographerName) {
    return <p>No photographer selected.</p>;
  }

  const photographerImages = data.filter(
    (photo) => photo.namePhotographer === photographerName
  );

  const openModal = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  return (
    <div className="profile-details-page2">
      <div className="profile-detailss">
        {photographerImages.length > 0 && (
          <div className="photo-gallery2">
            <h3>
              Artworks by <span>{photographerName}</span>
            </h3>

            <div className="gallery-grid2">
              {photographerImages.map((photo) => (
                <div key={photo.id} className="gallery-item2">
                  <img
                    src={photo.image}
                    alt={photo.name}
                    className="gallery-image2"
                    loading="lazy"
                    onClick={() => openModal(photo)}
                    style={{ backgroundColor: "#eee" }}
                  />
                  <div className="gallery-overlay2">
                    <h4>{photo.name}</h4>
                    <p>{photo.size} cm</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {isModalOpen && selectedImage && (
          <div className="modal-overlay2" onClick={closeModal}>
            <div
              className="modal-content2"
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={selectedImage.image}
                alt={selectedImage.name}
                className="modal-image2"
                loading="lazy"
                style={{ backgroundColor: "#eee" }}
              />

              <div className="modal-info2">
                <h4>{selectedImage.name}</h4>
                <div className="modal-actions2">
                  <Link
                    to={`/GazaPhoto/${selectedImage.id}`}
                    className="details-btn2"
                  >
                    View Details
                  </Link>

                  <a
                    href={selectedImage.StripLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="buy-btn2"
                  >
                    Buy Now
                  </a>
                </div>
              </div>

              <button className="close-button2" onClick={closeModal}>
                ×
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileDetails;
